import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, retry, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VenturesService {

  private strUserID: string = '1';
  private ComServiceSecureData: any;

  constructor(private _http: HttpClient) {
    this.ComServiceSecureData = sessionStorage.getItem('security-token') == null ? '' : JSON.parse(sessionStorage.getItem('security-token'));
  }

  //THIS IS SERVICE FOR GET ALL AGENTS LIST
  GetAllAmenitiesList(): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/venture-project/getamenitiesinfo/', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL AGENTS LIST
  SaveVentureDEtails(e: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/venture-project/addupdateventureinfo/', e, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL AGENTS LIST
  GetVentureDetails(vID: any, uID: any, active: number): Observable<any> {
    console.log('GetVentureDetails: Called with parameters:', {
      vID: vID,
      vIDType: typeof vID,
      uID: uID,
      uIDType: typeof uID,
      active: active
    });

    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    // Build the URL
    const url = environment.apiUrl + 'api/venture-project/getventuredetails?ventureId=' + vID + '&userId=' + uID + '&status=' + active;
    console.log('GetVentureDetails: Making POST request to URL:', url);
    console.log('GetVentureDetails: Request body is null (using query params)');

    return this._http.post(url, null, httpOptions).pipe(
      tap((response) => {
        console.log('GetVentureDetails: Response received successfully:', response);
      }),
      tap(null, (error) => {
        console.error('GetVentureDetails: Error occurred before retry:', {
          status: error.status,
          statusText: error.statusText,
          message: error.message,
          error: error.error,
          url: url
        });
      }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError((error) => {
        console.error('GetVentureDetails: Final error after retries:', {
          status: error.status,
          statusText: error.statusText,
          message: error.message,
          error: error.error,
          url: url
        });

        // Log more details about the error response
        if (error.error && typeof error.error === 'object') {
          console.error('GetVentureDetails: Error body details:', JSON.stringify(error.error));
        }

        return this.handleError(error);
      })
    );
  }

  //THIS IS SERVICE FOR GET ALL AGENTS LIST
 GetHomeVentureDetails(p_type?: string, price?: string, areas?: string, pId?: number): Observable<any> {
    // Build URL with query parameters
    const url = `${environment.apiUrl}api/venture-project/gethomeventuredetails`;
    const params = new HttpParams()
        .set('pType', p_type || '')
        .set('amount', price || '')
        .set('aCode', areas || '')
        .set('ProjectId', pId?.toString() || '0');
    
    // ✅ Make POST request with empty body, but parameters in URL
    return this._http.post(url, null, { params }).pipe(
        retry(2),
        catchError(this.handleError)
    );
}

  //THIS IS SERVICE UPLOAD IMAGE
  UploadImage(e: any, uploadType: string): Observable<any> {
    return this._http.post<any>(environment.apiUrl + 'api/documents/PostFile/' + uploadType + '/', e).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  SaveRating(e: any): Observable<any> {

    return this._http.post<any>(environment.apiUrl + 'api/user/addorupdatecontentrating', e).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }


  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(error);
  }

  //THIS IS THE FUNCATION FOR CONVERT TO LOCAL(YYYY-MM-DD) DATE FORMAT BY GIVEN DATE FORMAT
  private ConvertToDate(strD: any): string {
    return new Date(new Date(strD).getFullYear(), new Date(strD).getMonth(), ((new Date(strD).getDate()) + 1)).toISOString().slice(0, 10);
  }


  // Add this method to VenturesService
  LikeVenture(projectId: number, userId: number): Observable<any> {
    const params = new HttpParams()
      .set('projectId', projectId.toString())
      .set('userId', userId.toString());
    return this._http.get<any>(`${environment.apiUrl}/api/Venture/LikeVenture`, { params });
  }

}
